import { ProductSearchResponseModel } from '@shared/models/product-search-response.model';
import { UserData } from '@schemas/user.interface';
import { FeedErrorsResponseModel } from '@services/product.service';

export class ProductHelper {
  getPriceOnSite(item: ProductSearchResponseModel): number {
    return item.regular_price.find(_ => _.currency === item.base_currency).value;
  }

  getPriceOnSiteByCurrency(item: ProductSearchResponseModel, userPreferredCurrency: string): number {
    return item.regular_price.find(_ => _.currency === userPreferredCurrency).value;
  }

  getForYouPrice(item: ProductSearchResponseModel): number {
    return item.cost.find(_ => _.currency === item.base_currency).value;
  }

  getForYouPriceByCurrency(item: ProductSearchResponseModel, userPreferredCurrency: string): number {
    return item.cost.find(_ => _.currency === item.base_currency).value;
  }

  getDiscountPrice(item: ProductSearchResponseModel): number {
    return item.discount_price.find(_ => _.currency === item.base_currency).value;
  }

  getDiscountPriceByCurrency(item: ProductSearchResponseModel, userPreferredCurrency: string): number {
    return item.discount_price.find(_ => _.currency === userPreferredCurrency).value;
  }

  getTranslatedBrandName(item: ProductSearchResponseModel, user: UserData): string {
    return item.brand_name_translation.find(_ => _.lang === user.languageName).value;
  }

  getSortByOptions(): Array<SelectOption> {
    return [
      { label: 'Sort by Newest to Oldest', value: 'creation_timestamp-desc' },
      { label: 'Sort by Oldest to Newest', value: 'creation_timestamp-asc' },
      { label: 'Sort by A to Z', value: 'name.keyword-asc' },
      { label: 'Sort by Z to A ', value: 'name.keyword-desc' },
    ];
  }

  getTodaysFeedErrors(resp: FeedErrorsResponseModel) {
    const todaysErrors = [];
    const getObjectsRegex = /(?<=\{)(.*?)(?=\})/gm;
    const descriptionsErrors = resp.descriptionsErrors.match(getObjectsRegex)
      ? resp.descriptionsErrors.match(getObjectsRegex)
      : [];
    const brandsErrors = resp.brandsErrors.match(getObjectsRegex) ? resp.brandsErrors.match(getObjectsRegex) : [];
    const conditionRatesErrors = resp.conditionRatesErrors.match(getObjectsRegex)
      ? resp.conditionRatesErrors.match(getObjectsRegex)
      : [];
    const imagesErrors = resp.imagesErrors.match(getObjectsRegex) ? resp.imagesErrors.match(getObjectsRegex) : [];
    const allErrors = [...imagesErrors, ...brandsErrors, ...descriptionsErrors, ...conditionRatesErrors];

    allErrors.map(errorLine => {
      for (const cell of errorLine.split(',')) {
        const cellArr = cell.split('=');

        if (cellArr[0].trim() === 'timestamp') {
          const today = new Date().setHours(0, 0, 0, 0);
          const errorDay = new Date(parseInt(cellArr[1])).setHours(0, 0, 0, 0);

          if (today === errorDay) {
            todaysErrors.push(errorLine);
          }
        }
      }
    });

    return todaysErrors;
  }
}

export interface SelectOption {
  label: string;
  value: string;
}

export interface ProductSearchFilter {
  tvb_ordered?: boolean;
  includeOOS?: boolean;
  seller_sku_arr?: Set<string>;
  approval_status?: string;
  draft?: boolean;
  fromStock?: number;
  page?: number;
  size?: number;
  status?: string;
  sortField?: string;
  sortOrder?: string;
  rejection_reason?: string;
  rejection_reason_other?: string;
  searchfilter?: string;
}
